import React from 'react';

import { ContactCard } from 'common-ui/chat/chatSingle/ChatSingle.styles';
import Input from 'common-ui/input';

import { COMP_DETAILS } from '../../ActionPlanConstans';
import {
  CompCard,
  CompCardSpan,
  CompensationGrid,
  Container,
  Title,
} from '../EmployeeSteps.styles';

const Step4Compensation = ({ formData, errors, submitted, isReadOnly, handleCompChange }) => (
  <>
    <Container>
      <Title>Configure Compensation</Title>
      <CompensationGrid>
        {Object.keys(COMP_DETAILS).map((key) => (
          <CompCard key={key} $variant={COMP_DETAILS[key].type}>
            <Input
              label={COMP_DETAILS[key].label}
              disabled={isReadOnly}
              type="number"
              placeholder="0"
              value={formData.compensationConfig[key] ?? ''}
              onChange={(e) => handleCompChange(key, e.target.value)}
              error={submitted ? errors[`compensationConfig.${key}`] : null}
              onWheel={(e) => e.target.blur()}
            />
            <CompCardSpan>{COMP_DETAILS[key].subText}</CompCardSpan>
          </CompCard>
        ))}
      </CompensationGrid>
    </Container>
  </>
);

export default Step4Compensation;
